// src/redux/slices/workflowSlice.js - CORREGIDO con estados reales
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import workflowApi from '../../api/workflowApi';

// Async thunks para las operaciones del workflow
export const iniciarInscripcion = createAsyncThunk(
  'workflow/iniciarInscripcion',
  async (entidadId, { rejectWithValue }) => {
    try {
      const response = await workflowApi.iniciarInscripcion(entidadId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const obtenerEstadoInscripcion = createAsyncThunk(
  'workflow/obtenerEstadoInscripcion',
  async (entidadId, { rejectWithValue }) => {
    try {
      console.log('Redux: Solicitando estado para entidad:', entidadId);
      const response = await workflowApi.obtenerEstadoInscripcion(entidadId);
      console.log('Redux: Respuesta estado:', response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const validarRegistroCompleto = createAsyncThunk(
  'workflow/validarRegistroCompleto',
  async (entidadId, { rejectWithValue }) => {
    try {
      const response = await workflowApi.validarRegistroCompleto(entidadId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const obtenerDocumentosRequeridos = createAsyncThunk(
  'workflow/obtenerDocumentosRequeridos',
  async (workflowNegocioId, { rejectWithValue }) => {
    try {
      console.log('Redux: Obteniendo documentos para workflow:', workflowNegocioId);
      const response = await workflowApi.obtenerDocumentosRequeridos(workflowNegocioId);
      console.log('Redux: Documentos obtenidos:', response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// PASO 1: Subir documento (solo sube el archivo, queda en estado SUBIDO = 8)
export const subirDocumento = createAsyncThunk(
  'workflow/subirDocumento',
  async (documentoData, { rejectWithValue }) => {
    try {
      console.log('Redux: Subiendo documento (paso 1 - estado 8):', documentoData);
      const response = await workflowApi.subirDocumento(documentoData);
      console.log('Redux: Documento subido:', response.data);
      return response.data;
    } catch (error) {
      console.error('Redux: Error subiendo documento:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// PASO 2: Radicar documento ya subido (cambia de SUBIDO=8 a RADICADO=2)
export const radicarDocumento = createAsyncThunk(
  'workflow/radicarDocumento',
  async (radicarData, { rejectWithValue }) => {
    try {
      console.log('Redux: Radicando documento (paso 2 - estado 8->2):', radicarData);
      const response = await workflowApi.radicarDocumento(radicarData);
      console.log('Redux: Documento radicado:', response.data);
      return response.data;
    } catch (error) {
      console.error('Redux: Error radicando documento:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// PASO 3A: Iniciar revisión de documento (Admin) - cambia de RADICADO=2 a EN_REVISION=3
export const iniciarRevisionDocumento = createAsyncThunk(
  'workflow/iniciarRevisionDocumento',
  async (documentoId, { rejectWithValue }) => {
    try {
      console.log('Redux: Iniciando revisión (estado 2->3) para documento:', documentoId);
      const response = await workflowApi.iniciarRevisionDocumento(documentoId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// PASO 3B: Finalizar revisión de documento (Admin - Aprobar/Rechazar)
export const finalizarRevisionDocumento = createAsyncThunk(
  'workflow/finalizarRevisionDocumento',
  async (revisionData, { rejectWithValue }) => {
    try {
      console.log('Redux: Finalizando revisión (estado 3->4/5/6/7):', revisionData);
      const response = await workflowApi.finalizarRevisionDocumento(revisionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const obtenerResumenEstados = createAsyncThunk(
  'workflow/obtenerResumenEstados',
  async (workflowNegocioId, { rejectWithValue }) => {
    try {
      const response = await workflowApi.obtenerResumenEstados(workflowNegocioId);
      return response.data.resumenEstados;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  // Estado del workflow actual
  workflowActual: null,
  estadoWorkflow: null,
  resumenEstados: null,
  
  // Documentos
  documentosRequeridos: [],
  documentosCargando: {},
  
  // Estados de carga
  loading: {
    iniciarInscripcion: false,
    obtenerEstado: false,
    validarRegistro: false,
    obtenerDocumentos: false,
    subirDocumento: false,        // Para paso 1 (8 = SUBIDO)
    radicarDocumento: false,      // Para paso 2 (8->2 = SUBIDO->RADICADO)
    iniciarRevision: false,       // Para paso 3A (2->3 = RADICADO->EN_REVISION)
    finalizarRevision: false,     // Para paso 3B (3->4/5/6/7)
    obtenerResumen: false
  },
  
  // Errores
  error: null,
  errores: {},
  
  // UI
  modalSubirDocumento: {
    abierto: false,
    documentoSeleccionado: null
  },
  
  modalRevisionDocumento: {
    abierto: false,
    documentoSeleccionado: null
  }
};

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
    // Limpiar errores
    limpiarError: (state) => {
      state.error = null;
      state.errores = {};
    },
    
    // NUEVO: Limpiar estado del workflow (para cambio de entidad)
    limpiarEstadoWorkflow: (state) => {
      console.log('🧹 Redux: Limpiando estado del workflow para nueva entidad');
      state.workflowActual = null;
      state.estadoWorkflow = null;
      state.resumenEstados = null;
      state.documentosRequeridos = [];
      state.documentosCargando = {};
      state.error = null;
      state.errores = {};
      
      // Reset de estados de loading
      state.loading = {
        iniciarInscripcion: false,
        obtenerEstado: false,
        validarRegistro: false,
        obtenerDocumentos: false,
        subirDocumento: false,
        radicarDocumento: false,
        iniciarRevision: false,
        finalizarRevision: false,
        obtenerResumen: false
      };
      
      // Cerrar modales si están abiertos
      state.modalSubirDocumento = {
        abierto: false,
        documentoSeleccionado: null
      };
      
      state.modalRevisionDocumento = {
        abierto: false,
        documentoSeleccionado: null
      };
    },

    // Controlar modales
    abrirModalSubirDocumento: (state, action) => {
      state.modalSubirDocumento.abierto = true;
      state.modalSubirDocumento.documentoSeleccionado = action.payload;
    },
    
    cerrarModalSubirDocumento: (state) => {
      state.modalSubirDocumento.abierto = false;
      state.modalSubirDocumento.documentoSeleccionado = null;
    },
    
    abrirModalRevisionDocumento: (state, action) => {
      state.modalRevisionDocumento.abierto = true;
      state.modalRevisionDocumento.documentoSeleccionado = action.payload;
    },
    
    cerrarModalRevisionDocumento: (state) => {
      state.modalRevisionDocumento.abierto = false;
      state.modalRevisionDocumento.documentoSeleccionado = null;
    },
    
    // Resetear workflow completo (más agresivo que limpiarEstadoWorkflow)
    resetearWorkflow: (state) => {
      console.log('🔄 Redux: Reset completo del workflow');
      return { ...initialState };
    },
    
    // Actualizar estado de carga de documento específico
    actualizarCargaDocumento: (state, action) => {
      const { documentoId, cargando } = action.payload;
      state.documentosCargando[documentoId] = cargando;
    }
  },
  
  extraReducers: (builder) => {
    // Iniciar Inscripción
    builder
      .addCase(iniciarInscripcion.pending, (state) => {
        state.loading.iniciarInscripcion = true;
        state.error = null;
      })
      .addCase(iniciarInscripcion.fulfilled, (state, action) => {
        state.loading.iniciarInscripcion = false;
        state.workflowActual = action.payload;
      })
      .addCase(iniciarInscripcion.rejected, (state, action) => {
        state.loading.iniciarInscripcion = false;
        state.error = action.payload?.mensaje || 'Error al iniciar inscripción';
      })
      
    // Obtener Estado
    builder
      .addCase(obtenerEstadoInscripcion.pending, (state) => {
        state.loading.obtenerEstado = true;
        state.error = null;
      })
      .addCase(obtenerEstadoInscripcion.fulfilled, (state, action) => {
        state.loading.obtenerEstado = false;
        state.estadoWorkflow = action.payload?.estado;
        console.log('Redux: Estado workflow actualizado:', action.payload);
      })
      .addCase(obtenerEstadoInscripcion.rejected, (state, action) => {
        state.loading.obtenerEstado = false;
        state.error = action.payload?.mensaje || 'Error al obtener estado';
      })
      
    // Validar Registro
    builder
      .addCase(validarRegistroCompleto.pending, (state) => {
        state.loading.validarRegistro = true;
        state.error = null;
      })
      .addCase(validarRegistroCompleto.fulfilled, (state, action) => {
        state.loading.validarRegistro = false;
        if (action.payload?.esExitoso) {
          // Registro completo validado
        }
      })
      .addCase(validarRegistroCompleto.rejected, (state, action) => {
        state.loading.validarRegistro = false;
        state.error = action.payload?.mensaje || 'Error al validar registro';
      })
      
    // Obtener Documentos
    builder
      .addCase(obtenerDocumentosRequeridos.pending, (state) => {
        state.loading.obtenerDocumentos = true;
        state.error = null;
      })
      .addCase(obtenerDocumentosRequeridos.fulfilled, (state, action) => {
        state.loading.obtenerDocumentos = false;
        // Manejar diferentes formatos de respuesta del API
        if (action.payload?.documentos) {
          state.documentosRequeridos = action.payload.documentos;
        } else if (Array.isArray(action.payload)) {
          state.documentosRequeridos = action.payload;
        } else if (action.payload?.data && Array.isArray(action.payload.data)) {
          state.documentosRequeridos = action.payload.data;
        } else {
          state.documentosRequeridos = [];
        }
        console.log('Redux: Documentos actualizados:', state.documentosRequeridos);
      })
      .addCase(obtenerDocumentosRequeridos.rejected, (state, action) => {
        state.loading.obtenerDocumentos = false;
        state.error = action.payload?.mensaje || 'Error al obtener documentos';
        state.documentosRequeridos = [];
      })
      
    // PASO 1: Subir Documento (estado final: 8 = SUBIDO)
    builder
      .addCase(subirDocumento.pending, (state, action) => {
        state.loading.subirDocumento = true;
        state.error = null;
        // Marcar documento específico como cargando
        const documentoId = action.meta.arg.tipoDocumentoId;
        if (documentoId) {
          state.documentosCargando[documentoId] = true;
        }
      })
      .addCase(subirDocumento.fulfilled, (state, action) => {
        state.loading.subirDocumento = false;
        // Limpiar estado de carga
        state.documentosCargando = {};
        
        console.log('Redux: Documento subido exitosamente (estado 8 - SUBIDO):', action.payload);
      })
      .addCase(subirDocumento.rejected, (state, action) => {
        state.loading.subirDocumento = false;
        state.error = action.payload?.mensaje || 'Error al subir documento';
        // Limpiar estado de carga
        state.documentosCargando = {};
        console.error('Redux: Error subiendo documento:', action.payload);
      })
    
      // NUEVO: Reemplazar Documento (mantiene estado 8)
    builder
      .addCase(reemplazarDocumento.pending, (state, action) => {
        state.loading.subirDocumento = true; // Usar mismo loading que subir
        state.error = null;
        // Marcar documento específico como cargando
        const documentoId = action.meta.arg.tipoDocumentoId;
        if (documentoId) {
          state.documentosCargando[documentoId] = true;
        }
      })
      .addCase(reemplazarDocumento.fulfilled, (state, action) => {
        state.loading.subirDocumento = false;
        // Limpiar estado de carga
        state.documentosCargando = {};
        
        console.log('Redux: Documento reemplazado exitosamente (mantiene estado 8):', action.payload);
      })
      .addCase(reemplazarDocumento.rejected, (state, action) => {
        state.loading.subirDocumento = false;
        state.error = action.payload?.mensaje || 'Error al reemplazar documento';
        // Limpiar estado de carga
        state.documentosCargando = {};
        console.error('Redux: Error reemplazando documento:', action.payload);
      })
      
    // PASO 2: Radicar Documento (estado 8->2: SUBIDO->RADICADO)
    builder
      .addCase(radicarDocumento.pending, (state) => {
        state.loading.radicarDocumento = true;
        state.error = null;
      })
      .addCase(radicarDocumento.fulfilled, (state, action) => {
        state.loading.radicarDocumento = false;
        
        console.log('Redux: Documento radicado exitosamente (estado 2 - RADICADO):', action.payload);
      })
      .addCase(radicarDocumento.rejected, (state, action) => {
        state.loading.radicarDocumento = false;
        state.error = action.payload?.mensaje || 'Error al radicar documento';
        console.error('Redux: Error radicando documento:', action.payload);
      })
      
    // PASO 3A: Iniciar Revisión (estado 2->3: RADICADO->EN_REVISION)
    builder
      .addCase(iniciarRevisionDocumento.pending, (state) => {
        state.loading.iniciarRevision = true;
        state.error = null;
      })
      .addCase(iniciarRevisionDocumento.fulfilled, (state, action) => {
        state.loading.iniciarRevision = false;
        console.log('Redux: Revisión iniciada (estado 3 - EN_REVISION):', action.payload);
      })
      .addCase(iniciarRevisionDocumento.rejected, (state, action) => {
        state.loading.iniciarRevision = false;
        state.error = action.payload?.mensaje || 'Error al iniciar revisión';
      })
      
    // PASO 3B: Finalizar Revisión (estado 3->4/5/6/7)
    builder
      .addCase(finalizarRevisionDocumento.pending, (state) => {
        state.loading.finalizarRevision = true;
        state.error = null;
      })
      .addCase(finalizarRevisionDocumento.fulfilled, (state, action) => {
        state.loading.finalizarRevision = false;
        state.modalRevisionDocumento.abierto = false;
        state.modalRevisionDocumento.documentoSeleccionado = null;
        
        console.log('Redux: Revisión finalizada:', action.payload);
      })
      .addCase(finalizarRevisionDocumento.rejected, (state, action) => {
        state.loading.finalizarRevision = false;
        state.error = action.payload?.mensaje || 'Error al finalizar revisión';
      })
      
    // Obtener Resumen
    builder
      .addCase(obtenerResumenEstados.pending, (state) => {
        state.loading.obtenerResumen = true;
        state.error = null;
      })
      .addCase(obtenerResumenEstados.fulfilled, (state, action) => {
        state.loading.obtenerResumen = false;
        state.resumenEstados = action.payload;
      })
      .addCase(obtenerResumenEstados.rejected, (state, action) => {
        state.loading.obtenerResumen = false;
        state.error = action.payload?.mensaje || 'Error al obtener resumen';
      });
  }
});

// Exportar acciones
export const {
  limpiarError,
  limpiarEstadoWorkflow,
  abrirModalSubirDocumento,
  cerrarModalSubirDocumento,
  abrirModalRevisionDocumento,
  cerrarModalRevisionDocumento,
  resetearWorkflow,
  actualizarCargaDocumento
} = workflowSlice.actions;

// *** SELECTOR CORREGIDO con estados reales ***
export const seleccionarDocumentosConEstadisticas = (state) => {
  const documentos = state.workflow.documentosRequeridos || [];
  
  // *** ESTADÍSTICAS CORREGIDAS SEGÚN TABLA REAL ***
  const estadisticas = {
    total: documentos.length,
    pendientes: documentos.filter(d => d.estadoDocumentoId === 1).length, // PENDIENTE
    subidos: documentos.filter(d => d.estadoDocumentoId === 8).length, // SUBIDO (NUEVO)
    radicados: documentos.filter(d => d.estadoDocumentoId === 2).length, // RADICADO
    enRevision: documentos.filter(d => d.estadoDocumentoId === 3).length, // EN_REVISION
    aprobados: documentos.filter(d => d.estadoDocumentoId === 4).length, // APROBADO
    rechazados: documentos.filter(d => d.estadoDocumentoId === 5).length, // RECHAZADO
    requierenCorreccion: documentos.filter(d => d.estadoDocumentoId === 6).length, // REQUIERE_CORRECCION
    pendientesRecarga: documentos.filter(d => d.estadoDocumentoId === 7).length // PENDIENTE_RECARGA
  };
  
  return {
    documentos,
    estadisticas,
    // Porcentaje basado en documentos completamente procesados (aprobados + rechazados finales)
    porcentajeCompletado: estadisticas.total > 0 
      ? Math.round(((estadisticas.aprobados + estadisticas.rechazados) / estadisticas.total) * 100)
      : 0
  };
};

export const reemplazarDocumento = createAsyncThunk(
  'workflow/reemplazarDocumento',
  async (documentoData, { rejectWithValue }) => {
    try {
      console.log('Redux: Reemplazando documento (estado 8):', documentoData);
      const response = await workflowApi.reemplazarDocumento(documentoData);
      console.log('Redux: Documento reemplazado:', response.data);
      return response.data;
    } catch (error) {
      console.error('Redux: Error reemplazando documento:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export default workflowSlice.reducer;